import { Pipe, PipeTransform } from '@angular/core';
import { convertToNumberWithDecimal } from '@app/_utils/number-util';

@Pipe({
  name: 'kzNumber',
})
export class KzNumberPipe implements PipeTransform {
  transform(val?: any, decimalNumber = 3): string {
    return convertToNumberWithDecimal(val, decimalNumber);
  }
}
